import React, { useState, useContext, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentFooter } from '../../../../../layout/Content'
import UnmovingProductsFooterStyle from './css/UnmovingProductsFooterStyle'
import ReportsController from '../../../../ReportsController'
import { appContext } from '../../../../../../App'
import { unmovingProductsContext } from './UnmovingProductsController'

function UnmovingProductsFooter(props) {
  const app = useContext(appContext)
  const unmovingProductsController = useContext(unmovingProductsContext)
  const setDate = unmovingProductsController.date[1]
  const [disableApplyButton, setDisableApplyButton] = useState(true)
  const [firstLoad, setFirstLoad] = useState(true)
  const setContent = app.content[1]
  const [dateInput, setDateInput] = useState(unmovingProductsController.date[0])

  const onChangeDate = (e) => {
    setFirstLoad(false)
    setDateInput({ ...dateInput, [e.target.id]: e.target.value })
  }

  const onClickApply = (e) => {
    setDisableApplyButton(true)
    setDate(dateInput)
  }

  useEffect(() => {
    if (!firstLoad) setDisableApplyButton(false)

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateInput])

  return (
    <ContentFooter>
      <div className='content-footer-container'>
        <div className='add-on-controls'>
          <div style={{marginRight: '10px'}}>
            <label htmlFor='year' style={{fontSize: '1rem', margin: 'auto', marginLeft: '0', marginRight: '0'}}>From:</label>&nbsp;
            <input id='from' type='date' value={dateInput.from} onChange={onChangeDate} />
          </div>
          <div style={{marginRight: '10px'}}>
            <label htmlFor='year' style={{fontSize: '1rem', margin: 'auto', marginLeft: '0', marginRight: '0'}}>To:</label>&nbsp;
            <input id='to' type='date' value={dateInput.to} onChange={onChangeDate} />
          </div>
          <div>
            <button
              id='btn-apply'
              onClick={onClickApply}
              disabled={disableApplyButton}>
              Apply
            </button>
          </div>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={() => { setContent(<ReportsController />) }}
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='list-alt'/>&nbsp;Back to Reports
          </button>
        </div>
        <div className='action-btn-container'>
          <button
            onClick={ () => { window.print() } }
            className='pospro-action-btn'>
            <FontAwesomeIcon icon='print'/>&nbsp;Print
          </button>
        </div>
      </div>
      <UnmovingProductsFooterStyle />
    </ContentFooter>
  )
}

export default React.memo(UnmovingProductsFooter)
